/**
 * Connectif ↔ Contact Form 7 bridge.
 *
 * Connectif's built-in form capture hooks the browser's native submit event,
 * but CF7 calls preventDefault() and submits over AJAX, so that native submit
 * never fires and the contact is never created. Instead we listen for CF7's
 * own success event and push a `form-submitted` event to Connectif explicitly.
 *
 * Opt-in is per form: add `connectif_form_id: <integrated-form-id>` to the CF7
 * form's "Additional settings" tab. theme-config.php turns that into a hidden
 * `connectif_form_id` field, which arrives here in event.detail.inputs. Forms
 * without the setting are ignored.
 */

document.addEventListener("wpcf7mailsent", (event) => {
  const inputs = event.detail?.inputs || [];
  const get = (name) => inputs.find((i) => i.name === name)?.value;

  const formId = get("connectif_form_id");
  const email = get("email");
  if (!formId || !email) return;

  const notify = () =>
    window.connectif.managed.sendEvents([
      {
        type: "form-submitted",
        formId,
        primaryKeyField: "email",
        payload: { email },
      },
    ]);

  if (window.connectif?.managed?.isInitialized?.()) {
    notify();
  } else {
    document.addEventListener("connectif.managed.initialized", notify, {
      once: true,
    });
  }
});
